module.exports = __webpack_public_path__ + "static/marino-store-3c49debc6f7fda5d4a0bf9b13f0c3c75.jpg";